<template>
  <div class="karton-suche-teaser__container">
    <div class="karton-suche-teaser__content">
      <div class="karton-suche-teaser__headline" :aria-label="$t('global.kartonsuche.teaser.aria.label')">
        {{ headline ?? $t('cartonsearch.headline') }}
      </div>
      <div class="karton-suche-teaser__text">
        {{ $t('cartonsearch.text') }}
      </div>
    </div>

    <form
      class="karton-suche-teaser"
      method="get"
      action="/kartonsuche/"
      @submit.prevent="onSubmit($event)"
    >
      <div class="form__group form__group--row">
        <div class="form__col-3">
          <div class="input">
            <label for="lengthInput" class="input__label">
              {{ $t('cartonsearch.length') }}
            </label>

            <div class="input__wrapper">
              <input id="lengthInput"
                name="l"
                type="number"
                :required="touched"
                min="1"
                :placeholder="$t('cartonsearch.unit')"
                @input="touched = true"
              >
            </div>
          </div>
        </div>
        <div class="form__col-3">
          <div class="input">
            <label for="widthInput" class="input__label">
              {{ $t('cartonsearch.width') }}
            </label>

            <div class="input__wrapper">
              <input
                  id="widthInput"
                name="b"
                type="number"
                :required="touched"
                min="1"
                :placeholder="$t('cartonsearch.unit')"
                @input="touched = true"
              >
            </div>
          </div>
        </div>
        <div class="form__col-3">
          <div class="input">
            <label for="heightInput" class="input__label">
              {{ $t('cartonsearch.height') }}
            </label>

            <div class="input__wrapper">
              <input
                  id="heightInput"
                name="h"
                type="number"
                :required="touched"
                min="1"
                :placeholder="$t('cartonsearch.unit')"
                @input="touched = true"
              >
            </div>
          </div>
        </div>

        <div class="form__col-3">
          <button
            class="karton-suche-teaser__button button button--alt"
            type="submit"
          >
            {{ buttonText ?? $t('cartonsearch.button') }}
          </button>
        </div>

        <div
          class="form__col-12 input__error | input-error"
          v-if="showErrorMessage"
        >
          <div
            class="error-container form__col-9"
            v-html="$t('validation.kartonsuche.default')"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  props: {
    headline: String,
    buttonText: String
  },
  data() {
    return {
      showErrorMessage: false,
      touched: false,
    }
  },
  methods: {
    onSubmit(event) {
      /**@type HTMLFormElement*/
      let form = event.target

      if (!this.touched) {
        this.touched = true
        return
      }

      let firstInvalidElement
      let elements = Array.from(form.elements)
      for (const element of elements) {
        if (element.validity.valid) {
          continue
        }

        firstInvalidElement = element
        break
      }

      this.showErrorMessage = !!firstInvalidElement
      if (firstInvalidElement) {
        firstInvalidElement.focus()
        return
      }

      form.submit()
    }
  },
}

</script>
